import { Component, OnInit } from '@angular/core';
import { KeyDropLocationService } from '../../../business-services/dealer-keyDrop-location.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { KeyDropLocationViewModel } from '../../../business-entities/dealer-keydrop-location-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-dealer-keydrop-location',
  templateUrl: './edit-dealer-keydrop-location.component.html'
})
export class EditDealerKeydropLocationComponent implements OnInit {
  keyDropLocation:KeyDropLocationViewModel;
  locationList:SelectListItemViewModel[];
  dealerList:DealerViewModel[];
  constructor(private service: KeyDropLocationService,
    public dealerBusinessService: DealerBusinessService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal,) { }

  ngOnInit(): void {
    const id = this.service.KeydropLocationId;
    this.getLocationList();
    this.getDetails(id);
    this.checkId();
  }

  private getDetails(id: number){
    this.spinner.show();
    this.service.getKeyDropLocationById(id).then(result => {
      this.keyDropLocation = result.responseObject;
    })
    this.spinner.hide();
  }

  async getLocationList() {
    await this.service.getLocationList().then((response) => {
      this.locationList = response.responseObject;
    });
  }
  OnClose(){
    this.activeModal.close({success:false})
  }

  checkId(){
    if(this.service.dealerId)
      this.service.isEdit = true;
  }

  EditDetails() {
    this.spinner.show();
    let successMessage = this.translate.instant("lblDetailsEdited");
    let errorMessage = this.translate.instant("lblDetailsAreNotEdited");
    this.service.updateKeyDropLocation(this.keyDropLocation).then(res => {
      if (res.responseCode == Constant.SuccessResponseCode) {
        this.toaster.success(successMessage);
        this.activeModal.close({ success: true
        });
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
        this.toaster.error(errorMessage);
      }
    })

  }
  getValue(locationTypeName: string) {
    this.keyDropLocation.locationType = parseInt(this.locationList.find(x => x.value == locationTypeName).value);
  }
}
